export const defaultConfirmationString = 'CONFIRM';
export const defaultDeletionString = 'DELETE';
